







import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavDesktopMenu extends BaseComponent {

    protected mounted(): void {
        this.$nextTick(function() {
            const showStatus = document.querySelectorAll('.top-nav-desktop-menu');
            showStatus.forEach((item) => {
                const topMenuContainer: HTMLElement = item as HTMLElement;
                topMenuContainer.style.display = 'block !important';
            });
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavDesktopMenu.vue